<div class="pt-6">
    <div class="p-2 ">
        <h3 [ngClass]="'text-'+globals.colorTheme">
            <i class=" material-icons">menu_book</i>
            Order
        </h3>
    </div>
    <mat-horizontal-stepper [linear]="isLinear" [selectedIndex]="activeStepIndex" #stepper labelPosition="bottom" class="allspace"
        (selectionChange)="onStepChange($event)">
        <mat-step [stepControl]="customerFormGroup" [editable]="isEditable">
            <div [formGroup]="customerFormGroup">
                <ng-template matStepLabel>Customer</ng-template>
                <strong *ngIf="!bookingRequest.customerInfo || isBillToSearch">{{customerHeading | uppercase }}</strong>
                <app-customer-search [selectedEmailType]="pendingAgreementConfig.emailType"
                    *ngIf="!bookingRequest.customerInfo || isBillToSearch" [forSalesOrder]=true
                    (sendResponseEventEmitter)="receiveCustomers($event)"></app-customer-search>
                <br>
                <br>
                <app-customer-list *ngIf="(!bookingRequest.customerInfo || isBillToSearch) && customers"
                    [forSalesOrder]="true" [customersDetailList]="customers"
                    (sendResponseEventEmitter)="receiveSelectedCustomer($event)">
                </app-customer-list>
                <div *ngIf="bookingRequest.customerInfo && !isBillToSearch">
                    <strong>{{'Ship to Customer' | uppercase }}</strong>
                    <br>
                    <br>
                    <mat-card appearance="outlined" class="margin_left_2" *ngIf="bookingRequest.customerInfo">
                        <mat-card-header>
                            <mat-card-title class="ta-order-shipto-name">{{bookingRequest.customerInfo.name}}-
                                ({{bookingRequest.customerInfo.nameId}})
                            </mat-card-title>
                            <mat-card-subtitle>
                                <div class="ta-order-shipto-addressline1"
                                    [style.display]="bookingRequest.customerInfo.addressline1 != '' ? 'block' : 'none'">
                                    {{bookingRequest.customerInfo.addressline1}},</div>
                                <div class="ta-order-shipto-addressline2"
                                    [style.display]="bookingRequest.customerInfo.addressline2 != '' ? 'block' : 'none'">
                                    {{bookingRequest.customerInfo.addressline2}}</div>
                                <div class="ta-order-shipto-city"
                                    [style.display]="bookingRequest.customerInfo.city != '' ? 'block' : 'none'">
                                    {{bookingRequest.customerInfo.city}},
                                    {{bookingRequest.customerInfo.state}}</div>
                                <div class="ta-order-shipto-phonenumber"
                                    [style.display]="bookingRequest.customerInfo.phoneNumber != '' ? 'block' : 'none'">
                                    {{bookingRequest.customerInfo.phoneNumber}}</div>
                                <div class="ta-order-shipto-contactinformation"
                                    [style.display]="bookingRequest.customerInfo.primaryContact && bookingRequest.customerInfo.primaryContact.ContactInformation!='' ? 'block' : 'none'">
                                    {{bookingRequest.customerInfo.primaryContact.ContactInformation}}</div>
                            </mat-card-subtitle>
                        </mat-card-header>
                        <a class="full-width text-center color_green magin_5 ta-order-shipto-change"
                            (click)="changeShipTo()">Change</a>
                    </mat-card>
                    <br>
                    <strong>{{'Bill to Customer' | uppercase }}</strong>
                    <br>
                    <br>
                    <mat-card appearance="outlined" class="margin_left_2" *ngIf="bookingRequest.billToCustomer">
                        <mat-card-header>
                            <mat-card-title class="ta-order-billto-name">{{bookingRequest.billToCustomer.name}}-
                                ({{bookingRequest.billToCustomer.nameId}})
                            </mat-card-title>
                            <mat-card-subtitle>
                                <div class="ta-order-billto-addressline1"
                                    [style.display]="bookingRequest.billToCustomer.addressline1 != '' ? 'block' : 'none'">
                                    {{bookingRequest.billToCustomer.addressline1}},</div>
                                <div class="ta-order-billto-addressline2"
                                    [style.display]="bookingRequest.billToCustomer.addressline2 != '' ? 'block' : 'none'">
                                    {{bookingRequest.billToCustomer.addressline2}}</div>
                                <div class="ta-order-billto-city"
                                    [style.display]="bookingRequest.billToCustomer.city != '' ? 'block' : 'none'">
                                    {{bookingRequest.billToCustomer.city}},
                                    {{bookingRequest.billToCustomer.state}}</div>
                                <div class="ta-order-billto-phonenumber"
                                    [style.display]="bookingRequest.billToCustomer.phoneNumber != '' ? 'block' : 'none'">
                                    {{bookingRequest.billToCustomer.phoneNumber}}</div>
                                <div class="ta-order-billto-contactinformation"
                                    [style.display]="bookingRequest.billToCustomer.primaryContact && bookingRequest.billToCustomer.primaryContact.ContactInformation!='' ? 'block' : 'none'">
                                    {{bookingRequest.billToCustomer.primaryContact.ContactInformation}}</div>
                            </mat-card-subtitle>
                        </mat-card-header>
                        <a class="full-width text-center color_green magin_5 ta-order-billto-chage"
                            (click)="changeBillTo()">Change</a>
                    </mat-card>
                    <br>
                    <span
                        *ngIf="bookingRequest.billToCustomer != undefined && bookingRequest.billToCustomer.priceLevel != undefined && bookingRequest.billToCustomer.priceLevel == ''">
                        <strong>{{'Price level' | uppercase }}</strong>
                        <br>
                        <br>
                        <mat-button-toggle-group [(value)]="customerPriceLevel" style="width: 100%; "
                            name="pricelevel1or2" aria-label="Font Style">
                            <mat-button-toggle value="1" (change)="recalculateAddedItem()"
                                class="full-width ta-order-ordertype-d">
                                {{sellingPrice1Label}}</mat-button-toggle>
                            <mat-button-toggle value="2" (change)="recalculateAddedItem()"
                                class="full-width ta-order-ordertype-p">
                                {{sellingPrice2Label}}</mat-button-toggle>
                        </mat-button-toggle-group>
                    </span>
                    <br>
                    <br>
                    <strong>{{'Credit Check' | uppercase }}</strong>
                    <br>
                    <br>
                    <mat-card appearance="outlined" *ngIf="bookingRequest.creditInfo">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Balance</th>
                                    <th scope="col" class="ta-order-credit-balance"> {{bookingRequest.creditInfo.balance
                                        | currency}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">Current</th>
                                    <td class="ta-order-credit-current"> {{bookingRequest.creditInfo.current |
                                        currency}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Past Due</th>
                                    <td class="ta-order-credit-pastdue"> {{bookingRequest.creditInfo.pastDue |
                                        currency}}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Available</th>
                                    <td>
                                        <span *ngIf="customerLimitType > 0"
                                            class="ta-order-credit-customerlimittype">{{customerLimitType |
                                            currency:'USD':'$':'1.2-2'}} </span>
                                        <span *ngIf="customerLimitType == 0">No Credit Limit</span>
                                        <span *ngIf="customerLimitType < 0">No Credit</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Prepay</th>
                                    <td class="ta-order-credit-prepay"> {{ myMath.abs(bookingRequest.creditInfo.prepay)
                                        | currency}}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Booking</th>
                                    <td class="ta-order-credit-booking"> {{ bookingRequest.creditInfo.booking |
                                        currency}}
                                    </td>
                                </tr>
                        </table>
                        <input class="ta-order-credit-text" matInput hidden formControlName="credit" required
                            [(ngModel)]="bookingRequest.creditInfo">
                    </mat-card>
                </div>
                <br>
                <div align="center">
                    <button id="selectFarmAndField" mat-button #selectFarmAndField="matButton" hidden
                        [ngClass]="'mat-focus-indicator ta-selectFarmAndField text-white magin_5 btn btn-'+globals.colorTheme"
                        (click)="getFarmAndField(stepper);"
                        *ngIf="isSalesProUser && bookingRequest.customerInfo  && !isBillToSearch && !isShipToSearch">Splits</button>
                    <button *ngIf="bookingRequest.customerInfo  && !isBillToSearch && !isShipToSearch" mat-button
                        matStepperNext
                        [ngClass]="'ta-order-customer-next text-white btn btn-sm btn-'+globals.colorTheme">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step [stepControl]="farmAndFieldGroup" [editable]="isEditable" *ngIf="isSalesProUser && isfarmAndFields">
            <form [formGroup]="farmAndFieldGroup">
                <ng-template matStepLabel>Farm and Field</ng-template>
                <span *ngIf="selectedFarmAndField != 'No farm and fields available.'">Below are farms and fields
                    asscoicated to your customer please select a farm or field.</span>
                <span *ngIf="selectedFarmAndField == 'No farm and fields available.'">There are no farms and fields
                    asscoicated to your customer.</span>
                <br>
                <br>
                <app-farm-field *ngIf="bookingRequest.customerInfo" [customer]="bookingRequest.customerInfo"
                    (sendResponseEventEmitter)="receiveFarmAndFields($event,stepper)"></app-farm-field>
                <br>
                <div align="center">
                    <button *ngIf="bookingRequest.customerInfo  && !isBillToSearch && !isShipToSearch" mat-button
                        matStepperNext
                        [ngClass]="'ta-order-customer-next text-white btn btn-sm btn-'+globals.colorTheme">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="statusFormGroup" [editable]="isEditable">
            <form [formGroup]="statusFormGroup" (ngSubmit)="onStatusSubmit()">
                <ng-template matStepLabel>Status</ng-template>
                <br>
                <strong>{{'Select pickup/delivery' | uppercase }}</strong>
                <br>
                <br>
                <mat-button-toggle-group [(value)]="bookingRequest.salesOrder.orderType" style="width: 100%;"
                    name="pickupDelivery" aria-label="Font Style">
                    <mat-button-toggle value="D" class="full-width ta-order-ordertype-d">
                        Delivery</mat-button-toggle>
                    <mat-button-toggle value="P" class="full-width ta-order-ordertype-p">
                        Pickup</mat-button-toggle>
                </mat-button-toggle-group>
                <br>
                <br>

                <ng-container *ngIf="isSalesProUser && bookingRequest.salesOrder.orderType == 'D'">
                    <section class="form-section">
                        <a (click)="showAddNewDeliveryPointForm=!showAddNewDeliveryPointForm" href="javascript:;"
                            class="ta-order-new-delivery-point-switch">
                            <span *ngIf="showAddNewDeliveryPointForm == false">Add New Delivery Point</span>
                            <span *ngIf="showAddNewDeliveryPointForm == true">Select Existing Delivery Point</span>
                        </a>
                    </section>

                    <div *ngIf="showAddNewDeliveryPointForm == false">
                        <strong>{{'Select
                            Delivery
                            Point' | uppercase
                            }}</strong>

                        <br>

                        <mat-form-field class="full-width">
                            <mat-label>Delivery Point</mat-label>
                            <mat-select class="ta-order-delivery-point"
                                [(value)]="bookingRequest.salesOrder.deliveryPointId">
                                <mat-option *ngFor="let deliveryPoint of deliveryPoints" [value]="deliveryPoint.Key"
                                    [ngClass]="'ta-order-orderlist-' + deliveryPoint.Key">
                                    {{deliveryPoint.Value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div *ngIf="showAddNewDeliveryPointForm == true">
                        <section class="form-section">
                            <mat-form-field class="full-width">
                                <mat-label>Delivery Point Name</mat-label>
                                <input matInput formControlName="deliveryPointName"
                                    class="ta-order-new-delivery-point form-field-margin"
                                    [(ngModel)]="bookingRequest.salesOrder.newDeliveryPoint.DeliveryPointName">
                            </mat-form-field>
                        </section>


                        <section class="form-section">
                            <mat-checkbox color="success" formControlName="allowsHeavyTruck"
                                [(ngModel)]="bookingRequest.salesOrder.newDeliveryPoint.AllowsHeavyTruck"
                                class="ta-order-new-deliverypoint-allow-heavy-truck form-field-margin">
                                <strong>{{'Allows Heavy Truck' | uppercase}}</strong>
                            </mat-checkbox>
                        </section>
                    </div>
                </ng-container>

                <br> <br>

                <strong>{{'Select Order Status' | uppercase }}</strong>
                <br>
                <mat-form-field class="full-width">
                    <mat-select class="ta-order-status-orderstatus" [(value)]="bookingRequest.salesOrder.orderStatus">
                        <mat-option *ngFor="let orderStatus of orderStatuses" [value]="orderStatus.id"
                            [ngClass]="'ta-order-orderlist-' + orderStatus.id.toLowerCase()">
                            {{orderStatus.value}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <br>

                <strong>{{'order fields' | uppercase }}</strong>
                <br>

                <mat-form-field class="full-width">
                    <mat-label>{{orderField1}}</mat-label>
                    <input maxlength="10" matInput formControlName="orderField1" class="ta-order-status-orderfield1"
                        [(ngModel)]="bookingRequest.salesOrder.orderField1">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>{{orderField2}}</mat-label>
                    <input maxlength="10" matInput formControlName="orderField2" class="ta-order-status-orderfield2"
                        [(ngModel)]="bookingRequest.salesOrder.orderField2">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>{{orderField3}}</mat-label>
                    <input maxlength="10" matInput formControlName="orderField3" class="ta-order-status-orderField3"
                        [(ngModel)]="bookingRequest.salesOrder.orderField3">
                </mat-form-field>
                <div align="center">
                    <button mat-button matStepperNext type="submit"
                        [ngClass]="'ta-order-status-next text-white btn btn-sm btn-'+globals.colorTheme">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="productsFormGroup" [editable]="isEditable">
            <div [formGroup]="productsFormGroup">
                <ng-template matStepLabel>Add Products</ng-template>
                <br>
                <strong *ngIf="!items && !selectedItem">{{'Search products' | uppercase }}</strong>
                <strong *ngIf="items">{{'Select products' | uppercase }}</strong>
                <br>
                <div *ngIf="!selectedItem">
                    <app-item-search [itemSearchType]="ItemSearchType" [forSalesOrder]="true"
                        [customerPriceLevel]="customerPriceLevel" (sendResponseEventEmitter)="receiveItems($event)">
                    </app-item-search>
                    <br>
                    <app-item-list [forSalesOrder]="true" [itemsDetailList]="items"
                        (sendResponseEventEmitter)="itemSelection($event)" [showLocationDetails]="false"
                        [isLocationSelectable]="true">
                    </app-item-list>
                </div>
                <div *ngIf="selectedItem">
                    <mat-card appearance="outlined" class="margin_left_2" *ngIf="bookingRequest.billToCustomer">
                        <mat-card-header>
                            <mat-card-title>{{bookingRequest.billToCustomer.name}}-
                                ({{bookingRequest.billToCustomer.nameId}})
                            </mat-card-title>
                            <mat-card-subtitle>
                                Available:
                                <span *ngIf="customerLimitType > 0">{{customerLimitType |
                                    currency:'USD':'$':'1.2-2'}} </span>
                                <span *ngIf="customerLimitType == 0">No Credit Limit</span>
                                <span *ngIf="customerLimitType < 0">No Credit</span>
                            </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                    <br>
                    <br>
                    <mat-card appearance="outlined">
                        <mat-card-header [ngClass]="'ta-itemlist-order-'+selectedItem.id">
                            <mat-card-title>{{selectedItem.name}} - ({{selectedItem.id}})</mat-card-title>
                            <mat-card-subtitle>
                                <div class="container">
                                    <div class="row"> On Hand: {{selectedItem.itemBalance.OnHandQuantity |
                                        number:'1.0-1'}}
                                    </div>
                                    <div class="row"> Position: {{selectedItem.itemBalance.PositionQuantity |
                                        number:'1.0-1'}}
                                    </div>
                                </div>
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-footer>
                            <a class="ta-order-product-cancel full-width text-center error-block magin_5"
                                (click)="cancel()">Cancel</a>
                        </mat-card-footer>
                    </mat-card>
                    <br>
                    <strong>{{'Provide details for selected product' | uppercase }}</strong>
                    <br>
                    <mat-form-field hidden class="half-width">
                        <mat-label></mat-label>
                        <input class="ta-itemdetails-addedItems" matInput formControlName="addedItems" type="number"
                            onlyNumber="true" placeholder="" [(ngModel)]="addedItems.length" data-hj-whitelist>
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>Quantity</mat-label>
                        <input (keyup.enter)="onEnter(stepper)" class="ta-itemdetails-quantity" matInput
                            formControlName="quantity" type="number" onlyNumber="true"
                            onKeyPress="if((this.value.length==14 && this.value.indexOf('.') > -1) || this.value.length == 13) return false;"
                            placeholder="" [(ngModel)]="selectedItem.quantity"
                            (input)="checkInput($event); CalculateAmount();" (focus)="onFocus($event);" min="0"
                            (blur)="onBlur($event);" data-hj-whitelist>
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>Unit of Measure</mat-label>
                        <input (keyup.enter)="onEnter(stepper)" class="ta-itemdetails-uom" matInput type="string"
                            placeholder="" formControlName="uom" [(ngModel)]="selectedItem.uom" readonly>
                    </mat-form-field>
                    <br>
                    <mat-form-field class="threequater-width">
                        <mat-label>Price/Unit</mat-label>
                        <input (keyup.enter)="onEnter(stepper)" class="ta-itemdetails-priceunit" matInput
                            formControlName="price" allowNegativeNumber placeholder="" [(ngModel)]="selectedItem.price"
                            disabled=false (input)="checkInput($event); CalculateAmount();">
                    </mat-form-field>
                    <span class="h7 quater-width">
                        <!-- <input matInput type="number" placeholder="Amount" [(ngModel)]="selectedItem.amount" disabled=true style="font-size:20px;"> -->
                        {{selectedItem.amount | currency:'USD':'$':'1.2-2'}}
                    </span>
                    <br>
                    <mat-form-field class="full-width">
                        <mat-label>Order Line Remarks</mat-label>
                        <input (keyup.enter)="onEnter(stepper)" maxlength="50" class="ta-itemdetails-orderlineremarks"
                            matInput formControlName="orderLineRemarks" [(ngModel)]="selectedItem.orderlineRemarks">
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>SHIP/PICKUP DATE</mat-label>
                        <input (keyup.enter)="onEnter(stepper)" class="ta-itemdetails-shipdate"
                            [min]="selectedItem.minDate" matInput [matDatepicker]="startingDate"
                            placeholder="SHIP/PICKUP DATE" formControlName="startDate"
                            [(ngModel)]="selectedItem.startDate" data-hj-whitelist>
                        <mat-datepicker-toggle matSuffix [for]="startingDate"></mat-datepicker-toggle>
                        <mat-datepicker #startingDate></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="half-width">
                        <mat-label>SHIP/PICKUP Time</mat-label>
                        <mat-select class="ta-itemdetails-shiptime" formControlName="shipmentTime"
                            [(value)]="selectedItem.shipmentTime">
                            <mat-option *ngFor="let slot of timeSlots" [value]="slot">
                                {{slot}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>EXPIRATION DATE</mat-label>
                        <input (keyup.enter)="onEnter(stepper)" class="ta-itemdetails-expiredate"
                            [min]="selectedItem.startDate" matInput [matDatepicker]="endingDate"
                            placeholder="EXPIRATION DATE" formControlName="endDate" [(ngModel)]="selectedItem.endDate"
                            data-hj-whitelist>
                        <mat-datepicker-toggle matSuffix [for]="endingDate"></mat-datepicker-toggle>
                        <mat-datepicker #endingDate></mat-datepicker>
                    </mat-form-field>
                    <div align="center" *ngIf="!isEditItem">
                        <button mat-button (click)="addItem()"
                            class="mat-stroked-button-WhiteBackground-GreenText ta-order-product-add-another color_green font_bold">+
                            Add Another
                        </button>
                        <br>
                        <br>
                        <button mat-button (click)="addItem(stepper);"
                            [ngClass]="'ta-order-product-review text-white btn btn-sm btn-'+globals.colorTheme"
                            [disabled]="selectedItem.quantity <= 0 || !validateItemDate(selectedItem)">
                            Review
                        </button>
                    </div>
                    <div align="center" *ngIf="isEditItem">
                        <button mat-button (click)="updateItem(stepper)"
                            [ngClass]="'ta-order-product-review text-white btn btn-sm btn-'+globals.colorTheme">Update</button>
                    </div>
                </div>
            </div>
        </mat-step>
        <!-- <mat-step [stepControl]="productsFormGroup" [editable]="isEditable">            
            <div >
                <ng-template matStepLabel>Add Products</ng-template>
                <br>
                <strong *ngIf="!items && !selectedItem">{{'Search products' | uppercase }}</strong>
                <strong *ngIf="items">{{'Select products' | uppercase }}</strong>
                <br>
                <div *ngIf="!selectedItem">
                    <app-item-search [forSalesOrder]="true" [customerPriceLevel]="customerPriceLevel"
                        (sendResponseEventEmitter)="receiveItems($event)">
                    </app-item-search>
                    <br>
                    <app-item-list [forSalesOrder]="true" [itemsDetailList]="items"
                        (sendResponseEventEmitter)="itemSelection($event)">
                    </app-item-list>
                </div>
                <div *ngIf="selectedItem">
                    <mat-card class="margin_left_2" *ngIf="bookingRequest.billToCustomer">
                        <mat-card-header>
                            <mat-card-title>{{bookingRequest.billToCustomer.name}}-
                                ({{bookingRequest.billToCustomer.nameId}})
                            </mat-card-title>
                            <mat-card-subtitle>
                                Available:
                                <span *ngIf="customerLimitType > 0">{{customerLimitType |
                                    currency:'USD':'$':'1.2-2'}} </span>
                                <span *ngIf="customerLimitType == 0">No Credit Limit</span>
                                <span *ngIf="customerLimitType < 0">No Credit</span>
                            </mat-card-subtitle>
                        </mat-card-header>
                    </mat-card>
                    <br>
                    <br>
                    <mat-card>
                        <mat-card-header [ngClass]="'ta-itemlist-order-'+selectedItem.id">
                            <mat-card-title>{{selectedItem.name}} - ({{selectedItem.id}})</mat-card-title>
                            <mat-card-subtitle>
                                <div class="container">
                                    <div class="row"> On Hand: {{selectedItem.itemBalance.OnHandQuantity |
                                        number:'1.0-1'}}
                                    </div>
                                    <div class="row"> Position: {{selectedItem.itemBalance.PositionQuantity |
                                        number:'1.0-1'}}
                                    </div>
                                </div>
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-footer>
                            <a class="ta-order-product-cancel full-width text-center error-block magin_5"
                                (click)="selectedItem=null">Cancel</a>
                        </mat-card-footer>
                    </mat-card>
                    <br>
                    <strong>{{'Provide details for selected product' | uppercase }}</strong>
                    <br>
                    <form [formGroup]="productsFormGroup">
                    <mat-form-field class="half-width"> 
                        <mat-label>SHIP/PICKUP DATE</mat-label>                                                   
                        <input class="ta-itemdetails-shipdate" [min]="selectedItem.minDate" matInput [matDatepicker]="startingDate"
                                    placeholder="SHIP/PICKUP DATE"                                     
                                    [(ngModel)]="selectedItem.startDate" data-hj-whitelist>
                                <mat-datepicker-toggle matSuffix [for]="startingDate"></mat-datepicker-toggle>
                                <mat-datepicker #startingDate></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="half-width">
                            <mat-label>EXPIRATION DATE</mat-label>
                            <input class="ta-itemdetails-expiredate" [min]="selectedItem.startDate" matInput
                            [matDatepicker]="endingDate" placeholder="EXPIRATION DATE" [(ngModel)]="selectedItem.endDate"                        
                            data-hj-whitelist>
                        <mat-datepicker-toggle matSuffix [for]="endingDate"></mat-datepicker-toggle>
                        <mat-datepicker #endingDate></mat-datepicker>
                        </mat-form-field>
                    <br>
                    <mat-form-field class="half-width">
                        <mat-label>Quantity *</mat-label>
                        <input class="ta-itemdetails-quantity" matInput  type="number"
                            onlyNumber="true"
                            onKeyPress="if((this.value.length==14 && this.value.indexOf('.') > -1) || this.value.length == 13) return false;"
                            placeholder="" [(ngModel)]="selectedItem.quantity"
                            (input)="checkInput($event); CalculateAmount();" (focus)="onFocus($event);" min="0"
                            (blur)="onBlur($event);" data-hj-whitelist>
                    </mat-form-field>
                    <mat-form-field class="half-width">
                        <mat-label>Unit of Measure</mat-label>
                        <input class="ta-itemdetails-uom" matInput type="string" placeholder="" 
                            [(ngModel)]="selectedItem.uom" readonly>
                    </mat-form-field>
                    <br>
                    <mat-form-field class="threequater-width">
                        <mat-label>Price/Unit *</mat-label>
                        <input class="ta-itemdetails-priceunit" matInput  min="0" type="number"
                            onKeyPress="if((this.value.length==14 && this.value.indexOf('.') > -1) || this.value.length == 13) return false;"
                            onlyNumber="true" placeholder="" [(ngModel)]="selectedItem.price" disabled=false
                            (input)="checkInput($event); CalculateAmount();">
                    </mat-form-field>
                    <span class="h7 quater-width">
                       
                        {{selectedItem.amount | currency:'USD':'$':'1.2-2'}}
                    </span>
                    <br>
                    <mat-form-field class="full-width">
                        <mat-label>Order Line Remarks</mat-label>
                        <input maxlength="50" class="ta-itemdetails-orderlineremarks" matInput
                             [(ngModel)]="selectedItem.lineRemarks">
                    </mat-form-field>                    
                    
                    <div align="center" *ngIf="!isEditItem">
                        <button mat-stroked-button (click)="addItem()"
                            class="ta-order-product-add-another color_green font_bold">+
                            Add Another
                        </button>
                        <br>
                        <br>
                        <button mat-button matStepperNext (click)="addItem();"
                            [ngClass]="'ta-order-product-review text-white btn btn-sm btn-'+globals.colorTheme"
                            [disabled]="selectedItem.quantity <= 0 || selectedItem.amount <= 0">
                            Review
                        </button>
                    </div>
                    <div align="center" *ngIf="isEditItem">
                        <button mat-button matStepperNext (click)="updateItem()"
                            [ngClass]="'ta-order-product-review text-white btn btn-sm btn-'+globals.colorTheme">Update</button>
                    </div>
                </form>
                </div>
            </div>
        </mat-step> -->
        <mat-step [stepControl]="reviewFormGroup" [editable]="isEditable">
            <ng-template matStepLabel>Review</ng-template>
            <div *ngIf="bookingRequest.customerInfo && !isBillToSearch">
                <strong>{{'Ship to Customer' | uppercase }}</strong>
                <br>
                <br>
                <mat-card appearance="outlined" class="margin_left_2" *ngIf="bookingRequest.customerInfo">
                    <mat-card-header>
                        <mat-card-title class="ta-order-review-shipto-name">{{bookingRequest.customerInfo.name}}-
                            ({{bookingRequest.customerInfo.nameId}})
                        </mat-card-title>
                        <mat-card-subtitle>
                            <div class="ta-order-review-shipto-addressline1"
                                [style.display]="bookingRequest.customerInfo.addressline1 != '' ? 'block' : 'none'">
                                {{bookingRequest.customerInfo.addressline1}},</div>
                            <div class="ta-order-review-shipto-addressline2"
                                [style.display]="bookingRequest.customerInfo.addressline2 != '' ? 'block' : 'none'">
                                {{bookingRequest.customerInfo.addressline2}}</div>
                            <div class="ta-order-review-shipto-city"
                                [style.display]="bookingRequest.customerInfo.city != '' ? 'block' : 'none'">
                                {{bookingRequest.customerInfo.city}},
                                {{bookingRequest.customerInfo.state}}</div>
                            <div class="ta-order-review-shipto-phonenumber"
                                [style.display]="bookingRequest.customerInfo.phoneNumber != '' ? 'block' : 'none'">
                                {{bookingRequest.customerInfo.phoneNumber}}</div>
                            <div class="ta-order-review-shipto-contactinformation"
                                [style.display]="bookingRequest.customerInfo.primaryContact && bookingRequest.customerInfo.primaryContact.ContactInformation!='' ? 'block' : 'none'">
                                {{bookingRequest.customerInfo.primaryContact.ContactInformation}}</div>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <a class="full-width text-center color_green magin_5 ta-order-review-shipto-change"
                        (click)="changeShipTo()">Change</a>
                </mat-card>
                <br>
                <strong>{{'Bill to Customer' | uppercase }}</strong>
                <br>
                <br>
                <mat-card appearance="outlined" class="margin_left_2" *ngIf="bookingRequest.billToCustomer">
                    <mat-card-header>
                        <mat-card-title class="ta-order-review-billto-name">{{bookingRequest.billToCustomer.name}}-
                            ({{bookingRequest.billToCustomer.nameId}})
                        </mat-card-title>
                        <mat-card-subtitle>
                            <div class="ta-order-review-billto-addressline1"
                                [style.display]="bookingRequest.billToCustomer.addressline1 != '' ? 'block' : 'none'">
                                {{bookingRequest.billToCustomer.addressline1}},</div>
                            <div class="ta-order-review-billto-addressline2"
                                [style.display]="bookingRequest.billToCustomer.addressline2 != '' ? 'block' : 'none'">
                                {{bookingRequest.billToCustomer.addressline2}}</div>
                            <div class="ta-order-review-billto-city"
                                [style.display]="bookingRequest.billToCustomer.city != '' ? 'block' : 'none'">
                                {{bookingRequest.billToCustomer.city}},
                                {{bookingRequest.billToCustomer.state}}</div>
                            <div class="ta-order-review-billto-phonenumber"
                                [style.display]="bookingRequest.billToCustomer.phoneNumber != '' ? 'block' : 'none'">
                                {{bookingRequest.billToCustomer.phoneNumber}}</div>
                            <div class="ta-order-review-billto-contactinformation"
                                [style.display]="bookingRequest.billToCustomer.primaryContact && bookingRequest.billToCustomer.primaryContact.ContactInformation!='' ? 'block' : 'none'">
                                {{bookingRequest.billToCustomer.primaryContact.ContactInformation}}</div>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <a class="full-width text-center color_green magin_5 ta-order-review-billto-change"
                        (click)="changeBillTo()">Change</a>
                </mat-card>
                <br>
            </div>
            <div *ngIf="addedItems.length > 0">
                <strong>{{'Selected product(s)' | uppercase }}</strong>
                <div *ngFor="let item of addedItems; let i=index;">
                    <mat-card appearance="outlined"
                        [ngClass]="'margin_left_2 ta-order-selecteditem-'+item.id.toLowerCase()"
                        *ngIf="bookingRequest.customerInfo && (i < 2 || isShowAllItems)">
                        <mat-card-header>
                            <mat-card-title>{{item.name}}- ({{item.id}})
                            </mat-card-title>
                            <mat-card-subtitle>
                                <div>
                                    {{item.quantity}} {{item.uom}} - {{item.price}} - {{item.startDate |
                                    date:'MM/dd/yy'}} - {{item.endDate.toLocaleDateString()}}
                                </div>
                            </mat-card-subtitle>
                        </mat-card-header>

                        <div>
                            <button class="mat-mdc-button-WhiteBackground-GreenText max-width-10per"
                                [ngClass]="'color_green magin_5 ta-order-selecteditem-edit-'+item.id.toLowerCase()"
                                mat-button matStepperPrevious (click)="editItem(item)">Edit</button>
                            <!-- <a class="color_green magin_5" mat-button matStepperPrevious (click)="editItem(item)">Edit</a> -->
                            <button class="mat-mdc-button-whiteBackground-BlackText max-width-10per"
                                [ngClass]=" 'magin_5 ta-order-selecteditem-remove-'+item.id.toLowerCase()" mat-button
                                (click)="removeItem(item)">Remove</button>
                        </div>
                    </mat-card>
                    <br>
                </div>
                <div *ngIf="addedItems.length > 2">
                    <a class="ta-order-item-viewall full-width text-center color_green magin_5" *ngIf="!isShowAllItems"
                        (click)="hideShowAllItems(true)">View
                        All Items</a>
                    <a class="ta-order-item-hide full-width text-center color_green magin_5" *ngIf="isShowAllItems"
                        (click)="hideShowAllItems(false)">Hide
                        Items</a>
                </div>

            </div>
            <mat-divider></mat-divider>
            <br>
            <div>
                <p class="alignleft header_medium">
                    TOTAL
                </p>
            </div>
            <div>
                <p class="ta-order-totalamount alignright header_medium total">
                    {{totalAmount | currency:'USD':'$':'1.2-2'}}
                </p>
                <br>
                <p class="alignright"> {{addedItems.length}} Product(s) </p>
            </div>
            <br>
            <br>
            <br>
            <div>
                <form [formGroup]="reviewFormGroup">
                    <!-- <strong>{{'Dates' | uppercase }}</strong>
                    <br>
                    <br> -->
                    <!-- <div>
                        <mat-form-field floatLabel=" never" class="full-width">
                            <input class="ta-order-shipdate" [min]="minDate" matInput [matDatepicker]="startingDate"
                                placeholder="SHIP/PICKUP DATE" (dateChange)="validateDates()"
                                [(ngModel)]="bookingRequest.startDate " data-hj-whitelist formControlName="shipDate"
                                required>
                            <mat-datepicker-toggle matSuffix [for]="startingDate"></mat-datepicker-toggle>
                            <mat-datepicker #startingDate></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field floatLabel=" never" class="full-width">
                            <input class="ta-order-expiredate" [min]="bookingRequest.startDate" matInput
                                [matDatepicker]="endingDate" placeholder="EXPIRATION DATE"
                                (dateChange)="validateDates()" [(ngModel)]="bookingRequest.expiryDate "
                                data-hj-whitelist formControlName="expireDate" required>
                            <mat-datepicker-toggle matSuffix [for]="endingDate"></mat-datepicker-toggle>
                            <mat-datepicker #endingDate></mat-datepicker>
                        </mat-form-field>
                    </div> -->

                    <br>
                    <br>
                    <mat-form-field class="full-width" *ngIf="requireTheirDocumentNumber">
                        <mat-label>{{'BL#/REFERENCE' | uppercase }}</mat-label>
                        <input maxlength="15" matInput formControlName="documentNumber" class="ta-order-document-number"
                            [(ngModel)]="bookingRequest.salesOrder.documentNumber">
                    </mat-form-field>
                    <br>
                    <strong>{{'Order Remarks' | uppercase }}</strong>
                    <br>
                    <br>
                    <div *ngFor="let orderRemark of bookingRequest.salesOrder.orderRemarks;">
                        <mat-form-field class="full-width">
                            <mat-label>{{orderRemark.label}}</mat-label>
                            <input maxlength="50" matInput [formControlName]="orderRemark.formGroup"
                                [ngClass]="'ta-order-orderremarks-'+orderRemark.orderRemarksId.toLowerCase()"
                                [required]="orderRemark.required" [(ngModel)]="orderRemark.value">
                        </mat-form-field>
                    </div>
                    <div align="center">
                        <div *ngIf="isSign" class="margin_20" style="border:0px solid rgb(255, 253, 253) !important;">
                            <div *ngIf="isSign && !signatureImage">
                                <span>
                                    <span style="color: red; background-color: white;"
                                        *ngIf="isSignatureRequired">*signature is required </span>
                                    <br>

                                    <app-signature-pad
                                        #signature
                                        style="background-color: white !important;"
                                        [height]="200"
                                        [minWidth]="5"
                                        backgroundColor="#ffffff"
                                        (drawStart)="drawStart()"></app-signature-pad>
                                    <br>
                                </span>
                                <input type="button" mat-button class="text-white btn btn-success"
                                    (click)="drawComplete()" value="Done" />
                                &nbsp;
                                <input mat-button type="button" value="Clear"
                                    class="text-white btn btn-warning pull-right" (click)="clearSign($event)" />

                            </div>
                            <div *ngIf="signatureImage">
                                <app-signature-pad
                                    [readonly]="true"
                                    [height]="200"
                                    [value]="signatureImage"
                                    backgroundColor="#ffffff"></app-signature-pad>
                                <div>
                                    <br>
                                    <button mat-stroked-button
                                        class="ta-order-resign font_bold btn btn-warning color_white"
                                        (click)="resign()">
                                        Re-Sign
                                    </button>
                                </div>
                            </div>
                            <br>
                        </div>
                        <br>
                        <div>
                            <button *ngIf="!isSign" mat-button
                                class="ta-order-sign mat-stroked-button-WhiteBackground-GreenText color_green font_bold"
                                (click)="sign()">Sign</button>
                        </div>
                        <br>
                        <br>
                        <button [hidden]="!isSign" [disabled]="OrderSignatureRequiredStatus || addedItems.length == 0"
                            mat-button (click)="onReviewSubmit($event)"
                            [ngClass]="'ta-order-createsalesorder text-white btn btn-sm btn-'+globals.colorTheme">
                            Create Sales Order
                        </button>

                    </div>
                </form>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>